var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 5,
    fill: "#FF4B4A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 21.5C10.634 21.5 7.5 18.366 7.5 14.5C7.5 10.634 10.634 7.5 14.5 7.5C18.366 7.5 21.5 10.634 21.5 14.5C21.5 18.366 18.366 21.5 14.5 21.5ZM14.5 22.5C18.9183 22.5 22.5 18.9183 22.5 14.5C22.5 10.0817 18.9183 6.5 14.5 6.5C10.0817 6.5 6.5 10.0817 6.5 14.5C6.5 18.9183 10.0817 22.5 14.5 22.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1464 11.1464C11.3417 10.9512 11.6583 10.9512 11.8536 11.1464L14.5 13.7929L17.1464 11.1464C17.3417 10.9512 17.6583 10.9512 17.8536 11.1464C18.0488 11.3417 18.0488 11.6583 17.8536 11.8536L15.2071 14.5L17.8536 17.1464C18.0488 17.3417 18.0488 17.6583 17.8536 17.8536C17.6583 18.0488 17.3417 18.0488 17.1464 17.8536L14.5 15.2071L11.8536 17.8536C11.6583 18.0488 11.3417 18.0488 11.1464 17.8536C10.9512 17.6583 10.9512 17.3417 11.1464 17.1464L13.7929 14.5L11.1464 11.8536C10.9512 11.6583 10.9512 11.3417 11.1464 11.1464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.c58d92b496964ccbd8e5c4d4b253e9f1.svg";
export { ForwardRef as ReactComponent };